import { render } from "./firstAnimation.vue?vue&type=template&id=12dbff21&scoped=true"
import script from "./firstAnimation.vue?vue&type=script&lang=js"
export * from "./firstAnimation.vue?vue&type=script&lang=js"

import "./firstAnimation.vue?vue&type=style&index=0&id=12dbff21&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12dbff21"]])

export default __exports__